/**
 * Filter Chips Component
 * Chip filter for status: All, Optimal, Needs Attention
 */

import React from 'react';

type FilterType = 'all' | 'optimal' | 'needs_attention';

interface FilterChipsProps {
    activeFilter: FilterType;
    onFilterChange: (filter: FilterType) => void;
}

const FilterChips: React.FC<FilterChipsProps> = ({ activeFilter, onFilterChange }) => {
    const filters: { id: FilterType; label: string }[] = [
        { id: 'all', label: 'All' },
        { id: 'optimal', label: 'Optimal' },
        { id: 'needs_attention', label: 'Needs Attention' },
    ];

    return (
        <div className="filter-chips">
            {filters.map((filter) => (
                <button
                    key={filter.id}
                    className={`filter-chip ${activeFilter === filter.id ? 'active' : ''} ${filter.id}`}
                    onClick={() => onFilterChange(filter.id)}
                >
                    {filter.label}
                </button>
            ))}
        </div>
    );
};

export default FilterChips;
